export default "__VITE_ASSET__Cz$i2LfI__"